import { signOut as cognitoSignOut } from "@/api/auth/cognitoAuth";

export async function signOut() {
  await cognitoSignOut();
  const savedMail = localStorage.getItem("mail") as string;
  const isRememberMe = localStorage.getItem("isRememberMe");
  localStorage.clear();
  if (isRememberMe === "true") {
    localStorage.setItem("mail", savedMail);
    localStorage.setItem("isRememberMe", isRememberMe);
  }
}
